import { type ReactElement } from 'react';
import { toast } from 'react-toastify';
import {
  AppVersionMonitor,
  AppVersionMessage,
  getStaleVersionToastCoreOptions,
  STALE_VERSION_TOAST_CLASS_NAME,
  STALE_VERSION_TOAST_ID,
} from '@rsos/app-version-info';
import { displayToast } from '@rsos/components/capstone/base/Toast';
import { useFlag } from '@rsos/flags';

const showPortalStaleVersionToast = (): void => {
  if (toast.isActive(STALE_VERSION_TOAST_ID)) {
    return;
  }

  displayToast({
    message: <AppVersionMessage onRefresh={() => window.location.reload()} />,
    options: getStaleVersionToastCoreOptions(),
    className: STALE_VERSION_TOAST_CLASS_NAME,
  });
};

export const AppVersionMonitorToast = (): ReactElement | null => {
  const appVersionMonitorEnabled = useFlag('app_version_monitor');

  if (!appVersionMonitorEnabled) {
    return null;
  }

  return (
    <AppVersionMonitor
      onStaleVersion={() => {
        showPortalStaleVersionToast();
      }}
    />
  );
};
